import * as Types from '../index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFirmAccountAddOnByNameQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;


export type GetFirmAccountAddOnByNameQuery = { __typename?: 'Query', firmAccountAddOnByName?: { __typename?: 'FirmAccountAddOnEntity', id: string, subscriptionStatus?: Types.StripeSubscriptionStatus | null, subscriptionCancelAtPeriodEnd?: boolean | null } | null };


export const GetFirmAccountAddOnByNameDocument = gql`
    query GetFirmAccountAddOnByName($name: String!) {
  firmAccountAddOnByName(name: $name) {
    id
    subscriptionStatus
    subscriptionCancelAtPeriodEnd
  }
}
    `;

/**
 * __useGetFirmAccountAddOnByNameQuery__
 *
 * To run a query within a React component, call `useGetFirmAccountAddOnByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirmAccountAddOnByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirmAccountAddOnByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFirmAccountAddOnByNameQuery(baseOptions: Apollo.QueryHookOptions<GetFirmAccountAddOnByNameQuery, GetFirmAccountAddOnByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFirmAccountAddOnByNameQuery, GetFirmAccountAddOnByNameQueryVariables>(GetFirmAccountAddOnByNameDocument, options);
      }
export function useGetFirmAccountAddOnByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFirmAccountAddOnByNameQuery, GetFirmAccountAddOnByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFirmAccountAddOnByNameQuery, GetFirmAccountAddOnByNameQueryVariables>(GetFirmAccountAddOnByNameDocument, options);
        }
export type GetFirmAccountAddOnByNameQueryHookResult = ReturnType<typeof useGetFirmAccountAddOnByNameQuery>;
export type GetFirmAccountAddOnByNameLazyQueryHookResult = ReturnType<typeof useGetFirmAccountAddOnByNameLazyQuery>;
export type GetFirmAccountAddOnByNameQueryResult = Apollo.QueryResult<GetFirmAccountAddOnByNameQuery, GetFirmAccountAddOnByNameQueryVariables>;
export const namedOperations = {
  Query: {
    GetFirmAccountAddOnByName: 'GetFirmAccountAddOnByName'
  }
}